import React, { useState } from "react";
import styles from "./dashboard.module.css";
import workshop from '../../assets/DashboardIcons/Circle_icon_(1).webp';
import trainer from '../../assets/DashboardIcons/Circle_icon_(2).webp';
import trainee from '../../assets/DashboardIcons/Circle_icon_(3).webp';
import region from '../../assets/DashboardIcons/Circle_icon_(4).webp';
import CountUp from 'react-countup';
import ScrollTrigger from 'react-scroll-trigger';
import { useTranslation } from "react-i18next";
import { LazyLoadImage } from "react-lazy-load-image-component";


export default function Dashboard() {
  const [counterAnime, setCounterAnime] = useState(false);
  const { t } = useTranslation();
  const infoItems = [
    // {
    //   title: `${t("visitors")}`,
    //   subTitle: `${t("3 million")}`,
    //   img: vistors

    // },
    {
      title: `${t("workshops")}`,
      counterStart: 0,
      counterEnd: 6000,
      img: workshop

    }, {
      title: `${t("Instructor")}`,
      counterStart: 0,
      counterEnd: 5000,
      img: trainer
    }, {
      title: `${t("learners")}`,
      counterStart: 0,
      counterEnd: 3100000,
      img: trainee

    }, {
      title: `${t("and North Africa region")}`,
      subTitle: `${t("Middle East")}`,
      img: region

    }
  ];
  return (
    <>
      <div className={`my-5 ${styles.mobileRemove}`}>
        <ScrollTrigger onEnter={() => setCounterAnime(true)} onExit={() => setCounterAnime(false)} >
          <div className={`${styles.Dashboard}`}>


            {infoItems.map((item, i) => (
              <section key={i} className={styles.singleInfo}>
                <LazyLoadImage src={item.img} alt='Icon_Img' />

                {item.counterStart !== undefined && item.counterEnd !== undefined ? (
                  counterAnime && (
                    <span className={styles.Count}>
                      {item.counterEnd === 1000000 && <span className={styles.CountPlus}>+</span>}

                      <CountUp start={item.counterStart} end={item.counterEnd} duration={2} delay={0.2} />
                    </span>
                  )
                ) : (
                  <span className={styles.Count} >{item.subTitle || 0}</span>
                )}
                <p>{item.title}</p>
              </section>
            ))}
          </div>
        </ScrollTrigger>
      </div>


    </>
  );
}
